<template>
   <el-table-column  
     :fixed="fixed" 
     :prop="prop" 
     :label="label"
     :width="width"
     :show-overflow-tooltip="showOverflowTooltip">
        <template slot-scope="scope">
            <span v-if="prop">{{scope.row[prop] || "--"}}</span>
            <span v-else>
               <slot :row="scope.row" :$index="scope.$index"></slot>          
            </span>
            
        </template>
   </el-table-column>
</template>
<script>
export default {
  props: {
    label:{
      type:String,
      default:""
    },
    fixed:{
      type:[String,Boolean],
      default:false,
    },
    prop:{
      type:String,
      default:"",
    },
    showOverflowTooltip:{
      type:Boolean,
      default:true
    },
    width:{
      type:[String,Number,Boolean],
      default:false
    }
  },
  mounted(){
  
  },
};
</script>



// WEBPACK FOOTER //
// src/components/childcomponents/elTableColumn/index.vue